import React, { useEffect, useState } from "react";
import Payment from "../../../../Components/Payment/Payment";
import PaymentSummary from "./PaymentSummary";
import PackagePaymentTermsConsent from "../../PackagesProfile/PackagePayment/PackagePaymentTermsConsent";
import "../../PackagesProfile/PackagePayment/PackagePayment.scss";
import { useSelectedResult } from "../../../../contexts/SelectedResultContext";

const PackagePayment = ({
  our_order_id,
  leftToPay,
  sumpaid,
  disabled,
  isConditionsConfirmed: isConditionsConfirmedProp,
  setIsConditionsConfirmed: setIsConditionsConfirmedProp,
  ...props
}) => {
  const ctx = useSelectedResult();
  const isConditionsConfirmed =
    isConditionsConfirmedProp !== undefined
      ? isConditionsConfirmedProp
      : ctx.isConditionsConfirmed;
  const setIsConditionsConfirmed =
    typeof setIsConditionsConfirmedProp === "function"
      ? setIsConditionsConfirmedProp
      : ctx.setIsConditionsConfirmed;

  const [termsAttemptHint, setTermsAttemptHint] = useState(false);

  useEffect(() => {
    if (isConditionsConfirmed) setTermsAttemptHint(false);
  }, [isConditionsConfirmed]);

  const enforcePaymentTerms = typeof setIsConditionsConfirmed === "function";

  return (
    <div className="package-payment-container">
      <div className="tw-flex tw-flex-col-reverse lg:tw-flex-row tw-gap-[5%] payment-content-wrapper">
        <div className="lg:tw-w-[35%]">
          <PaymentSummary our_order_id={our_order_id} {...props} />
        </div>

        <div className="tw-flex tw-flex-col tw-w-full lg:tw-flex-1 tw-min-w-0 tw-gap-3 package-payment-main-column">
          {enforcePaymentTerms ? (
            <PackagePaymentTermsConsent
              checked={!!isConditionsConfirmed}
              onChange={(v) => setIsConditionsConfirmed?.(v)}
              showAttemptHint={termsAttemptHint}
              checkboxId="organized-tour-payment-terms-consent-agent"
            />
          ) : null}

          <Payment
            our_order_id={our_order_id}
            leftToPay={leftToPay}
            sumpaid={sumpaid}
            selectedResult={ctx.selectedResult}
            paymentTermsAccepted={
              enforcePaymentTerms ? !!isConditionsConfirmed : undefined
            }
            onPaymentTermsBlocked={() => setTermsAttemptHint(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default PackagePayment;
